import timezones from './timezones';

/**
 * List of time zones based on this list that takes into account DST
 * https://en.wikipedia.org/wiki/List_of_tz_database_time_zones
 */
export function timeZonesList() {
  return timezones;
}
